import {Component, Input} from '@angular/core';
import {IonNav, NavController} from '@ionic/angular';
import { SupportContact } from '../../../domain/operator/frontEndConfig';
import { SupportContactContext } from '../../../domain/operator/frontEndConfig';
import {SupportContactComponent} from '../supportContact/supportContact.component';
import {ModalControllerService} from '../../../services/common/modalController.service';
import {ModalWithBackButtonDirective} from '../../modals/modalWithBackButton.directive';
import {IziviaPlatformService} from '../../../services/common/iziviaPlatform.service';

@Component({
    selector: 'support-contact-list',
    templateUrl: './supportContactList.component.html',
    styleUrls: ['./supportContactList.component.scss']
})
export class SupportContactListComponent extends ModalWithBackButtonDirective {

    @Input() technicalSupportContact: SupportContact;
    @Input() supportContacts: SupportContact[];
    @Input() supportContactContext: SupportContactContext;
    @Input() displayTechnicalSupportContactOrDefaultMessage: boolean = false;

    constructor(readonly modalControllerService: ModalControllerService,
        readonly platformService: IziviaPlatformService,
        protected readonly navController: NavController,
        private nav: IonNav) {
        super(modalControllerService, navController, platformService);
    }

    openSupportContact(supportContact: SupportContact): void {
        this.nav.push(SupportContactComponent, {
            supportContact: supportContact,
            supportContactContext: this.supportContactContext,
            ionNav: this.nav
        });
    }

    trackById(index: number, supportContact: SupportContact): string {
        return supportContact?.id;
    }
}
